<template>
<div>
  <main id="smooth-wrapper" role="main">
    <main-container></main-container>
  </main>
  <Modal></Modal>
</div>
</template>

<script>
import MainContainer from '@/_components/MainContainer';
import Modal from '@/_components/Modal';

export default {
  components: {
    MainContainer,
    Modal,
  },
  data() {
    return {
      scrollY : 0,
      winH: window.innerHeight,
    }
  },
  computed: {
    showLoad() {
      return this.$store.getters.showLoad;
    },
  },
  watch: {
    showLoad (isShow, isOld) {
      //console.log(isShow, isOld);
    },
  },
  mounted() {
  },
  methods: {
  }
}
</script>